import { BaseEntity } from "../system";


export enum IntegrationService {
  Telleroo,
  Ebay,
  Shopify,
  PartPro,
}

export const IntegrationServiceLookup: Record<IntegrationService, string> = {
  [IntegrationService.Telleroo]: "Telleroo",
  [IntegrationService.Ebay]: "Ebay",
  [IntegrationService.Shopify]: "Shopify",
  [IntegrationService.PartPro]: "PartPro",
};

export interface IIntegration extends BaseEntity {
  customerId: string;
  userId: string;
  expiry: string;
  service: IntegrationService;
}